import { render, staticRenderFns } from "./resetThreshold.vue?vue&type=template&id=25f07db2&lang=pug"
import script from "./resetThreshold.vue?vue&type=script&lang=js"
export * from "./resetThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports